import React from 'react';
import { RiCloseLine } from 'react-icons/ri';

const ImagePreviewModal = ({ isOpen, imageUrl, title, onClose }) => {
    if (!isOpen || !imageUrl) return null;

    return (
        <div 
            className="modal show d-block fade-in" 
            style={{ backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 1060 }} 
            tabIndex="-1"
            onClick={onClose}
        >
            <div 
                className="modal-dialog modal-dialog-centered modal-md" 
                onClick={(e) => e.stopPropagation()}
            >
                <div className="modal-content border-0 shadow-lg bg-dark text-white rounded-4 overflow-hidden">
                    <div className="modal-header border-0 pb-0 d-flex justify-content-between align-items-center">
                        <h6 className="modal-title fw-bold text-light mb-0">{title || 'Image Preview'}</h6>
                        <button 
                            type="button" 
                            className="btn btn-sm btn-icon btn-outline-light rounded-circle" 
                            onClick={onClose}
                            style={{ width: '32px', height: '32px' }}
                        >
                            <RiCloseLine size={20} />
                        </button>
                    </div>
                    <div className="modal-body text-center p-4">
                        <div className="d-inline-block position-relative rounded-4 overflow-hidden border border-secondary shadow">
                            <img 
                                src={imageUrl} 
                                alt={title || "Preview"} 
                                className="img-fluid rounded-4" 
                                style={{ maxHeight: '70vh', maxWidth: '100%', objectFit: 'contain' }} 
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ImagePreviewModal;
